import Vue from 'vue'
import Vuex from 'vuex'
import httpUtils from '@/api'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        initData: {},
        areaTotalArr: [],
        homeBanner: [],
        feverBanner: [],
        haiwaiBanner: [],
        // 用户输入的卡片
        editCard: {
            nickName: '', // 拜年对象
            cardTitle: '', // 贺卡标题
            aweText: '' // 祝福语
        },
        imgUrl: '',
        // 通过id拉取的卡信息
        card: {
            cardId: '',
            cardImg: '',
            hengtu: '',
            aweConfigList: [],
            aweList: [],
            cardTitle: '',
            detailText: '',
            nickName: '',
            leaderName: '',
            themeName: ''
        },
        myCards: [],
        createCardId: '',
        choosedBaseCardType: 1,
        choosedCardType: 11,
        needUpdateCard: false,
        choosedAwe: '', // 选择的祝福语
        identity: 1, // 1 我发起的; 2 我参加的; 3 我未参加的
        personal: {
            name: '',
            avatar: ''
        },
        cardConfigList: [],

        infoData: {}
    },
    getters: {
        editable (state) {
            return state.identity === 1
        },
        choosedCardConfig (state) {
            return state.cardConfigList.find((item) => item.baseCardType === state.choosedBaseCardType)
        },
        choosedCard (state, getters) {
            if (!getters.choosedCardConfig) return {}
            return getters.choosedCardConfig.cardList.find((item) => item.cardType === state.choosedCardType)
        },
        isDefaultAwe (state, getters) {
            // 还没保存过，肯定是默认祝福语
            if (!state.editCard.aweText) return true

            // 当前编辑页的祝福语是否为默认祝福语
            const defaultList = getters.choosedCardConfig.cardList.map((config) => config.defaultAweText)

            return defaultList.indexOf(state.editCard.aweText) !== -1
        },
        localCard (state, getters) {
            // 将本地编辑的卡片构造成与card类似的数据结构
            return {
                ...state.editCard,
                aweList: [
                    {
                        avatar: state.personal.avatar,
                        name: state.personal.name,
                        text: state.editCard.aweText,
                        identity: 1
                    }
                ],
                cardImg: getters.choosedCard.cardImg,
                songSrc: getters.choosedCard.songSrc
            }
        }
    },
    mutations: {
        setImgUrl (state, imgUrl) {
            state.imgUrl = imgUrl
        },
        updateCardConfigList (state, config) {
            state.cardConfigList = config
        },
        chooseBaseCardType (state, type) {
            state.choosedBaseCardType = type
            // 同时默认选中第一个cardType
            const target = state.cardConfigList.find((item) => item.baseCardType === type)
            state.choosedCardType = target.cardList[0].cardType
        },
        chooseCardType (state, type) {
            state.choosedCardType = type
        },
        chooseAwe (state, content) {
            state.choosedAwe = content
        },
        clearChoosedAwe (state) {
            state.choosedAwe = ''
        },
        // 更新编辑记录
        updateEditCard (state, editCard) {
            state.editCard = editCard
        },
        // 更新拉取到的卡信息
        updateCard (state, cardRes) {
            const { cardInfo, identity } = cardRes
            state.card = cardInfo
            state.identity = identity
        },
        updateMyCards (state, cards) {
            state.myCards = cards
        },
        // 记录生成的卡片id
        markCardId (state, id) {
            state.createCardId = id
        },
        updateIdentity (state, identity) {
            state.identity = identity
        },
        updateNeedUpdate (state, status) {
            state.needUpdateCard = status
        },
        setInitData (state, initData) {
            state.initData = Object.assign({}, state.initData, initData)
            state.areaTotalArr = state.initData.getAreaInfo.areaTotal
        },
        setHomeBanner (state, homeBanner) {
            state.homeBanner = homeBanner
        },
        setFeverBanner (state, feverBanner) {
            state.feverBanner = feverBanner
        },
        setHaiwaiBanner (state, haiwaiBanner) {
            state.haiwaiBanner = haiwaiBanner
        },
        test (state, data) {
            console.log('騰訊接口數據 Data', data);
        }
    },
    actions: {
        async getCardConfigList ({ commit }) {
            const res = await httpUtils('getPageConfig')
            if (res.code !== 0) {
                throw res
            }
            commit('updateCardConfigList', res.cardConfigList)
        },
        async getMyCards ({ commit }) {
            const res = await httpUtils('getMyCard')
            if (res.code !== 0) {
                throw res
            }
            commit('updateMyCards', res.myCardList)
        },
        async createCard ({ state, commit }) {
            const res = await httpUtils('createCard', {
                ...state.editCard,
                cardType: state.choosedCardType
            })
            if (res.code !== 0) {
                throw res
            }
            commit('markCardId', res.cardId)
        },
        async getCardDetail ({ commit }, cardId) {
            const res = await httpUtils('getCard', cardId)
            if (res.code !== 0) {
                throw res
            }
            commit('updateCard', res)
        },
        async addCard (_, cardId) {
            const res = await httpUtils('addCard', cardId)
            if (res.code !== 0) {
                throw res
            }
        },
        async confirmJoin ({ state, commit }) {
            const res = await httpUtils('joinCard', {
                cardId: state.card.cardId,
                aweText: state.editCard.aweText
            })
            if (res.code !== 0) {
                throw res
            }
        },
        // PENDING
        /*  async getInitBannerConfig ({ state, commit }, { cityCode }) {
        const requestSeparateApi = () => {
            httpUtils('homeBanner', { cityCode }, 'FeverBannerH5')
            .then(({ code, data }) => {
                if (code === 0 && data.length) {
                commit('setHomeBanner', data)
                }
            })

            httpUtils('feverBanner', { cityCode }, 'FeverBannerH5')
            .then(({ code, data }) => {
                if (code === 0 && data.length) {
                commit('setFeverBanner', data)
                } else {
                commit('setFeverBanner', [])
                }
            })
            .catch((err) => {
                console.error(err)
                commit('setFeverBanner', [])
            })

            httpUtils('haiwaiBanner', { cityCode }, 'FeverBannerH5')
            .then(({ code, data }) => {
                if (code === 0 && data.length) {
                commit('setHaiwaiBanner', data)
                }
            })
        }
        try {
            const { dataMap: { homeBanner, feverBanner, haiwaiBanner }, code } = await httpUtils(
            'getMutiBanner',
            { cityCode, bannerList: ['homeBanner', 'feverBanner', 'haiwaiBanner'] },
            'FeverBannerH5'
            )
            if (code === 0) {
            commit('setHomeBanner', homeBanner)
            commit('setFeverBanner', feverBanner)
            commit('setHaiwaiBanner', haiwaiBanner)
            } else {
            requestSeparateApi()
            }
        } catch (err) {
            console.error('批量接口调用失败', err)
            requestSeparateApi()
        }
        }, */

        async getnewInfoData ({ state, commit }) {
            console.log('----------------------------');

            let api = ''
            if (process.env.CDN_ENV === 'pre') {
                api = 'https://api.exmoo.com/get_novel_pneumonia'
            } else {
                api = 'https://sitapi.exmoo.com:15343/get_novel_pneumonia'
            }

            axios.get(api)
                .then(function (res) {
                    let data = res.data
                    console.log('data', data);
                    let countryArr = data.data.pneumonia.data.country;
                    let jsonData = {
                        getChinaTotal: {},
                        getAreaInfo: {},
                        getForeignTotal: {},
                        getForeignInfo: {}, // 國家列表
                        getForeignHistory: {},
                        getHubeiInfo: {},
                        getRate: {},
                        getCityInfoByCode: '',
                        world: {},
                        macau: {},
                        china: {},
                        province: [],
                        time: ''
                    }

                    jsonData.macau = data.data.pneumonia.data.macau;
                    jsonData.china = data.data.pneumonia.data.china;
                    jsonData.world = data.data.pneumonia.data.world;
                    jsonData.time = data.data.pneumonia.time.substr(0, 16);

                    let provinceArr = data.data.pneumonia.data.province;
                    for (let i in provinceArr) {
                        let item = provinceArr[i]
                        jsonData.province[i] = {}
                        jsonData.province[i].country = item.area;
                        jsonData.province[i].country_tw = item.area_tw;
                        jsonData.province[i].country_cn = item.area;
                        jsonData.province[i].country_cn = item.area;
                        jsonData.province[i].confirm = item.total.confirm; // 累計確診
                        jsonData.province[i].suspect = item.total.suspect; // 累計疑似
                        jsonData.province[i].heal = item.total.heal; // 累計治癒
                        jsonData.province[i].dead = item.total.dead; // 累計死亡
                        jsonData.province[i].modifyConfirm = item.today.confirm; // 今日增數
                        jsonData.province[i].modifySuspect = item.today.suspect; // 今日疑似
                        jsonData.province[i].modifyHeal = item.today.heal; // 今日治癒
                        jsonData.province[i].modifyDead = item.today.dead; // 今日死亡

                        jsonData.province[i].modifyConfirmDesc = item.today.confirm; // 今日增數
                        jsonData.province[i].modifySuspectDesc = item.today.suspect; // 今日疑似
                        jsonData.province[i].modifyHealDesc = item.today.heal; // 今日治癒
                        jsonData.province[i].modifyDeadDesc = item.today.dead; // 今日死亡
                    }

                    // 模擬原來騰訊接口的格式
                    let obj = {
                        recentTime: data.data.pneumonia.time,
                        foreignTotal: [],
                        code: 0,
                        message: 'success'
                    }
                    let arr = []
                    for (let i in countryArr) {
                        let item = countryArr[i];
                        arr[i] = {};
                        arr[i].id = item.area_id;
                        arr[i].country_tw = item.area_tw;
                        arr[i].country = item.area_en;
                        arr[i].country_cn = item.area
                        arr[i].confirm = item.total.confirm; // 累計確診
                        arr[i].suspect = item.total.suspect; // 累計疑似
                        arr[i].heal = item.total.heal; // 累計治癒
                        arr[i].dead = item.total.dead; // 累計死亡
                        arr[i].modifyConfirm = item.today.confirm; // 今日增數
                        arr[i].modifySuspect = item.today.suspect; // 今日疑似
                        arr[i].modifyHeal = item.today.heal; // 今日治癒
                        arr[i].modifyDead = item.today.dead; // 今日死亡

                        arr[i].modifyConfirmDesc = item.today.confirm; // 今日增數
                        arr[i].modifySuspectDesc = item.today.suspect; // 今日疑似
                        arr[i].modifyHealDesc = item.today.heal; // 今日治癒
                        arr[i].modifyDeadDesc = item.today.dead; // 今日死亡

                        // console.log(arr[i].country_tw, arr[i].country_cn, arr[i].country);
                    }
                    obj.foreignTotal = arr;
                    jsonData.getForeignInfo = obj;

                    // getChinaTotal
                    let china = data.data.pneumonia.data.china;
                    let chinaObj = {
                        data: {
                            chinaTotal: {}
                        },
                        code: 0,
                        message: 'success'
                    }
                    chinaObj.data.chinaTotal.confirm = china.total.confirm;
                    chinaObj.data.chinaTotal.suspect = china.total.suspect;
                    chinaObj.data.chinaTotal.dead = china.total.dead;
                    chinaObj.data.chinaTotal.heal = china.total.heal;
                    chinaObj.data.chinaTotal.nowConfirm = china.today.confirm;
                    chinaObj.data.chinaTotal.nowHeavy = china.today.heal;
                    chinaObj.data.chinaTotal.nowConfirmDesc = china.today.confirm;
                    chinaObj.data.chinaTotal.nowHeavyDesc = china.today.heal;
                    chinaObj.data.chinaTotal.no_symptom = china.total.no_symptom;

                    chinaObj.data.chinaTotal.showAdd = '';
                    chinaObj.data.chinaTotal.dataTime = '';
                    chinaObj.data.chinaTotal.dataFrom = '';
                    chinaObj.data.chinaTotal.notice = '';
                    chinaObj.data.chinaTotal.addNoShowText = '';
                    chinaObj.data.chinaTotal.import = '';
                    chinaObj.data.chinaTotal.importDesc = '';
                    chinaObj.data.chinaTotal.virusInfo = [];
                    // console.log('chinaObj', chinaObj);
                    jsonData.getChinaTotal = chinaObj;

                    // getForeignTotal
                    // let getForeignTotalObj = {
                    //     data: {
                    //         confirm: 1348280,
                    //         dead: 78810,
                    //         foreignTotalUpdateTime: '2020-04-08 12:21:09',
                    //         showAdd: 1,
                    //         addNoShowText: '数据来源各国（地区）官方通报及权威媒体，较上日变化数据待更新',
                    //         foreignTotal: {
                    //             confirm: 1348280,
                    //             suspect: 0,
                    //             dead: 78810,
                    //             heal: 223783,
                    //             heavy: 0,
                    //             nowConfirm: 1045687,
                    //             confirmDesc: '1348280',
                    //             suspectDesc: '0',
                    //             deadDesc: '78810',
                    //             healDesc: '223783',
                    //             heavyDesc: '0',
                    //             nowConfirmDesc: '1045687',
                    //             showAdd: 1
                    //         },
                    //         foreignDayModify: {
                    //             confirm: 66634,
                    //             confirmDesc: 'new+66634',
                    //             nowConfirm: 52092,
                    //             nowConfirmDesc: 'new+52092',
                    //             heal: 8890,
                    //             healDesc: 'new+8890',
                    //             dead: 5653,
                    //             deadDesc: 'new+5653',
                    //             showAdd: 1
                    //         }
                    //     },
                    //     code: 0,
                    //     message: 'success'
                    // }
                    // jsonData.getForeignTotal = getForeignTotalObj

                    commit('setInitData', jsonData);
                    console.log('我定义的新数据', state.initData);
                })
                .catch(function (err) {
                    console.log('错误', err);
                });
        },

        async getInitMapDetailData ({ state, commit }, batchReq) {
            return;

            // eslint-disable-next-line no-unreachable
            try {
                // throw new Error('测试调用失败的情况');
                const { batchRsp, code } = await httpUtils('getInfoBatch', { batchReq }, 'THPneumoniaOuterDataService')
                if (code !== 0) {
                    let result = {}
                    for (let func in batchReq) {
                        try {
                            const res = await httpUtils(func, JSON.parse(batchReq[func]), 'THPneumoniaOuterDataService')
                            result[func] = res
                        } catch (error) {
                            console.error(`${func} 接口调用失败`, error)
                        }
                    }
                    return result
                }
                let result = {
                    getKeyCity: JSON.parse(batchRsp.getKeyCity),
                    getCityInfo: JSON.parse(batchRsp.getCityInfo)
                }
                if (batchRsp.getHubeiInfo) {
                    result.getHubeiInfo = JSON.parse(batchRsp.getHubeiInfo)
                }
                return result
            } catch (err) {
                console.error('批量接口调用失败，使用兜底逻辑，单个接口依次调用', err)
                let result = {}
                for (let func in batchReq) {
                    try {
                        const res = await httpUtils(func, JSON.parse(batchReq[func]), 'THPneumoniaOuterDataService')
                        result[func] = res
                    } catch (error) {
                        console.error(`${func} 接口调用失败`, error)
                    }
                }
                return result
            }
        },
        async getInitHomeData ({ state, commit }, { context }) {
            // 二次进入首页 就不需要在请求百科接口，首次进入才请求getBaike
            const batchReq = {
                getChinaTotal: JSON.stringify({ none: 'none' }),
                getAreaInfo: JSON.stringify({ none: 'none' }),
                getForeignTotal: JSON.stringify({ none: 'none' }),
                getForeignInfo: JSON.stringify({ none: 'none' }),
                getForeignHistory: JSON.stringify({ none: 'none' }),
                getHubeiInfo: JSON.stringify({ none: 'none' }),
                getRate: JSON.stringify({ none: 'none' }),
                getCityInfoByCode: JSON.stringify({ cityCode: '420100' }) // 首页获取的是武汉的数据
            }
            // const firstInit = Object.keys(state.initData).length === 0;
            // if (firstInit) {
            //   batchReq.getBaike = JSON.stringify({
            //     cmd: 'GetActiveDataV4',
            //     offset: 0,
            //     limit: 3
            //   });
            // }
            try {
                // throw new Error('测试调用失败的情况');
                const { batchRsp, code } = await httpUtils(
                    'getInfoBatch',
                    { batchReq },
                    'THPneumoniaOuterDataService',
                    context
                )
                if (code !== 0) {
                    Object.keys(batchReq).forEach(async (func) => {
                        try {
                            const res = await httpUtils(
                                func,
                                JSON.parse(batchReq[func]),
                                'THPneumoniaOuterDataService',
                                context
                            )
                            console.log('testRes', res);

                            commit('test', {
                                [func]: res
                            })
                        } catch (error) {
                            console.error(`${func} 接口调用失败`, error)
                            // 调用失败，设置error的flag
                            commit('test', {
                                [func]: { code: -1 }
                            })
                        }
                    })
                    return
                }
                const result = {
                    getChinaTotal: JSON.parse(batchRsp.getChinaTotal),
                    getAreaInfo: JSON.parse(batchRsp.getAreaInfo),
                    getForeignTotal: JSON.parse(batchRsp.getForeignTotal),
                    getForeignInfo: JSON.parse(batchRsp.getForeignInfo),
                    getForeignHistory: JSON.parse(batchRsp.getForeignHistory),
                    getHubeiInfo: JSON.parse(batchRsp.getHubeiInfo),
                    getRate: JSON.parse(batchRsp.getRate),
                    getCityInfoByCode: JSON.parse(batchRsp.getCityInfoByCode)
                }
                // if (firstInit) {
                //   result.getBaike = JSON.parse(batchRsp.getBaike);
                // }
                commit('test', result)
            } catch (err) {
                console.error('批量接口调用失败，使用兜底逻辑，单个接口依次调用', err)
                Object.keys(batchReq).forEach(async (func) => {
                    try {
                        const res = await httpUtils(
                            func,
                            JSON.parse(batchReq[func]),
                            'THPneumoniaOuterDataService',
                            context
                        )
                        commit('test', {
                            [func]: res
                        })
                    } catch (error) {
                        console.error(`${func} 接口调用失败`, error)
                        // 调用失败，设置error的flag
                        commit('test', {
                            [func]: { code: -1 }
                        })
                    }
                })
            }
        }
    },
    modules: {}
})
